exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n@media (max-width: 991px) {\n.brand-bar__subtitle {\n    font-size: 10px !important;\n}\n.brand-bar__title, .brand-bar__subtitle {\n    width: 80% !important;\n}\n}", ""]);

// exports
